import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { PreferencesProvider } from "./context/PreferencesContext";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <PreferencesProvider>
      <App />
    </PreferencesProvider>
  </StrictMode>
);
